import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ShopPage from "../pages/shop/page";
import CustomGiftBoxPage from "../pages/custom-gift-box/page";
import OccasionsPage from "../pages/occasions/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import BlogPage from "../pages/blog/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shop",
    element: <ShopPage />,
  },
  {
    path: "/custom-gift-box",
    element: <CustomGiftBoxPage />,
  },
  {
    path: "/occasions",
    element: <OccasionsPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;